export const ExpertiseStyle = {
  baseStyle: {},
  variants: {
    wrapper: {
      phone: {
        margins: {
          minWidth: ['100%', 'auto'],
          marginTop: '16px',
          marginLeft: ['-20px', 0],
          marginRight: ['-20px', 0],
        },
        stickyBox: {
          position: 'sticky',
          top: 0,
          zIndex: 3,
        },
        otherStickyBox: {
          position: ['sticky', 'static'],
          top: ['40px', 'auto'],
          left: ['40px', 'auto'],
          zIndex: [5, 0],
        },
        checkboxFlex: {
          display: ['flex', 'block'],
          justifyContent: 'center',
          borderBottom: 0,
          borderColor: 'ORANGE',
          boxShadow: ['base', 'none'],
        },
      },
      mainBox: {
        marginTop: ['4px', 0],
        paddingTop: '.5rem',
        border: [0, '1px solid #707070'],
        backgroundColor: 'GRAY_LIGHT',
        borderRadius: [0, '4px 4px 0 0'],
        display: ['flex', 'block'],
        flexDirection: 'column',
      },
      advancedSearchText: {
        padding: '0 0 0 16px',
        fontSize: '20px',
        fontWeight: 600,
        color: 'GRAY_DARK',
        textTransform: 'uppercase',
        backgroundColor: 'transparent',
      },
      inputFlex: {
        justifyContent: 'center',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: ['0', '0 8px'],
      },
      inputGroup: {
        margin: ['0 12px 8px', '0 8px 8px'],
        maxWidth: ['100%', null, '450px'],
        minWidth: '220px',
        flexBasis: '250px',
        flexGrow: 1,
        inputField: {
          marginRight: '.5rem',
        }
      },
      simpleGridCheckboxGroup: {
        backgroundColor: 'WHITE',
        borderLeft: [0, '1px solid #707070'],
        borderRight: [0, '1px solid #707070'],
        overflowY: ['hidden', 'scroll'],
        scrollBehaviour: 'smooth',
        maxHeight: ['100%', '200px'],
        padding: ['12px', '12px 0 12px 16px'],
      },
      computerSkillsCheckboxGroup: {
        backgroundColor: 'WHITE',
        borderLeft: [0, '1px solid #707070'],
        borderRight: [0, '1px solid #707070'],
        borderTop: [0, '1px solid #707070'],
        borderRadius: '4px 0 0 0',
        overflowY: ['hidden', 'scroll'],
        scrollBehaviour: 'smooth',
        maxHeight: ['100%', '200px'],
        padding: ['12px', '12px 0 12px 16px'],
      },
      workExperienceCheckboxGroup: {
        borderLeft: [0, '1px solid #707070'],
        borderRight: [0, '1px solid #707070'],
        borderTop: [0, '1px solid #707070'],
        borderRadius: '4px 0 0 0',
        overflowY: ['hidden', 'scroll'],
        scrollBehaviour: 'smooth',
        maxHeight: ['100%', '200px'],
        padding: ['12px', '12px 0 12px 16px'],
      },
      newBox: {
        border: '1px solid',
        borderColor: 'GRAY_2',
        backgroundColor: 'GRAY_LIGHT',
        maxWidth: '100%',
        padding: '4px 8px 0',
        borderRadius: '0 0 4px 4px',
      },
      newInputGroup: {
        margin: '0 8px 8px 8px',
        maxWidth: '350px',
        minWidth: '250px',
        flexBasis: '250px',
        flexGrow: 1,
      },
      newInput: {
        borderColor: 'GRAY_2',
        backgroundColor: 'WHITE',
      },
      skillsBox: {
        mainBox: {
          border: '1px solid',
          borderColor: 'NAVY',
          borderRadius: '4px',
          text: {
            borderRadius: '4px 4px 0 0',
            borderBottom: '1px solid',
            borderColor: 'NAVY',
            padding: '0 0 0 16px',
            fontSize: '20px',
            fontWeight: 600,
            color: 'NAVY',
            backgroundColor: '#e0e7ff',
          },
          wrap: {
            padding: '1rem 1rem',
            margin: '0 0',
            spacing: 0,
          },
        },
        phoneBox: {
          minWidth: '100%',
          borderTop: '1px solid',
          borderBottom: '1px solid',
          borderColor: 'NAVY',
          backgroundColor: '#e0e7ff',
          borderRadius: 0,
          text: {
            borderRadius: 0,
            paddingLeft: 4,
            fontSize: '20px',
            fontWeight: 600,
            color: 'NAVY',
            textTransform: 'uppercase',
          },
          flexWrapper: {
            justifyContent: 'center',
            flexWrap: 'wrap',
            paddingBottom: 2,
          },
          flexItem: {
            margin: '2px',
            borderRadius: 4,
            backgroundColor: 'WHITE',
            flexDirection: 'row',
          },
          itemText: {
            color: 'NAVY',
            textTransform: 'uppercase',
            fontSize: '14px',
            fontWeight: 600,
            marginRight: '2px',
            marginLeft: '4px',
          },
          icon: {
            marginTop: '2px',
            marginLeft: 0,
            marginRight: '2px',
            color: 'NAVY',
          },
        },
        wrapped: {
          flex: {
            margin: '4px',
            padding: '4px 4px',
            borderRadius: '4px',
            backgroundColor: 'NAVY',
            flexDirection: 'row',
            text: {
              color: 'WHITE',
              textTransform: 'uppercase',
              fontSize: '16px',
              fontWeight: 600,
            },
            // icon: {
            //   marginTop: '4px',
            //   marginLeft: '4px',
            //   marginRight: '-2px',
            //   color: 'WHITE',
            // },
          },
        },
      },
    },
  },
};
